export interface ComposerReferenceSnapshot {
  selectedImageIds: string[];
  chatAttachments: Array<{url:string;name:string}>;
  attachedFile: {url:string;name:string} | null;
}
/** Consume only the exact composer values accepted by this request. */
export function consumeComposerReferences(current: ComposerReferenceSnapshot & {activeProjectId:number|null}, submitted: ComposerReferenceSnapshot, projectId:number|null): Partial<ComposerReferenceSnapshot> {
  if (current.activeProjectId !== projectId) return {};
  return {
    selectedImageIds: current.selectedImageIds === submitted.selectedImageIds ? [] : current.selectedImageIds,
    chatAttachments: current.chatAttachments.filter(attachment => !submitted.chatAttachments.includes(attachment)),
    attachedFile: current.attachedFile === submitted.attachedFile ? null : current.attachedFile,
  };
}
